import * as Apollo from '@apollo/client';
import { useQuery } from '@apollo/client';
import { useFeatureFlag } from './useFeatureFlag';

export default function usePersistedCacheQuery<Query, QueryVariables>(
  query: Apollo.DocumentNode,
  options: Apollo.QueryHookOptions<Query, QueryVariables>
): Apollo.QueryResult<Query, QueryVariables> {
  const result = useQuery<Query, QueryVariables>(query, {
    ...options,
    fetchPolicy: 'cache-and-network'
  });

  const isActuallyLoading =
    result.loading &&
    !result.client.readQuery({
      query,
      variables: options?.variables
    });

  const persistedCacheQueryEnabled = useFeatureFlag(
    'isTiWebTabPersistedCacheQueryEnabled'
  );
  return {
    ...result,
    loading: persistedCacheQueryEnabled ? isActuallyLoading : result.loading
  };
}
